import { useBackend } from "../../services";

export const useFetchTracks = () => {
  const { patch } = useBackend();
  const fetchTracks = (albumUuid: string) => patch(`albums/${albumUuid}`);
  return { fetchTracks };
};
